import styled, { css } from 'styled-components';

import { SurveyDialogDetails } from '@r1-frontend/survey/context/selectors';

import { Anchor } from '@r1-frontend/ui-kit/atoms/anchor';
import { Button } from '@r1-frontend/ui-kit/atoms/button';
import { H3 } from '@r1-frontend/ui-kit/atoms/typography/heading';
import { Text } from '@r1-frontend/ui-kit/atoms/typography/text';
import { Sheet } from '@r1-frontend/ui-kit/molecules/Sheet';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

const SurveySheet = styled(({
    isOpen,
    image,
    title,
    description,
    buttonText,
    externalLink,
    onStart,
    onClose,
    ...props
}: Omit<SurveyDialogDetails, 'name' | 'type'> & {
    onClose: () => void,
    onStart: () => void,
}) => (
    <Sheet isOpen={isOpen} onClose={onClose} {...props}>
        <div aria-label='main-content'>
            <div aria-label='text-content'>
                <div aria-label='image-container'>
                    <img src={image} alt='Логотип опроса'/>
                </div>
                <H3 dangerouslySetInnerHTML={{ __html: title }}/>
                <Text $size={'lg'} $color={'hint'} dangerouslySetInnerHTML={{ __html: description }}/>
            </div>
            <Anchor href={externalLink} target='_blank' rel='noopener'>
                <Button $type={'primary'} onClick={onStart}>{buttonText}</Button>
            </Anchor>
        </div>
    </Sheet>
))`
    ${({ theme }: ThemedProperties) => css`
        div[aria-label="main-content"] {
            display: flex;
            flex-direction: column;
            gap: ${theme.indents.m}px;

            div[aria-label="text-content"] {
                display: flex;
                flex-direction: column;
                gap: ${theme.indents.xxs}px;

                div[aria-label="image-container"] {
                    width: 112px;
                    height: 112px;
                    margin: 0 auto;

                    img {
                        width: 100%;
                        height: 100%;
                        object-position: center;
                        object-fit: contain;
                    }
                }
            }

            ${Button} {
                width: 100%;
            }
        }
    `};
`;

SurveySheet.displayName = 'SurveyDialog__mobile';

export { SurveySheet };
